import React, { useMemo } from 'react';
import { usePaginableSortedData } from 'src/backoffice-app-code/application/hooks/usePaginableSortedData';
import { GenericPaginableTable } from 'src/backoffice-app-code/components/tables/GenericPaginableTable';
import { Retailer } from '../../../models/Retailer';
import RetailersTableBody from './RetailersTableBody';

interface Props {
  retailers: Retailer[] | undefined;
  isLoading: boolean;
  errorMessage?: string;
}

export const RetailersTableContainer: React.FC<Props> = ({
  isLoading,
  retailers,
  errorMessage,
}) => {
  //genericki hook za paginaciju i sortiranje
  const { dataToShow, page, setPage, rowsPerPage, setRowsPerPage, setSortBy } =
    usePaginableSortedData(retailers, 'name'); //title je property name u Retailer modelu

  const tableLabels = useMemo(
    () => [
      // id mora biti unique
      // Obratiti paznju, id: mora biti ime polja iz modela ukoliko je sortable true!!!
      // ukoliko se prosledi sortable: true, onda se prikazuje strelica za sortiranje, i sort radi
      { id: 'logoImage', label: 'Slika' },
      { id: 'name', label: 'Naziv', sortable: true },
      { id: 'pib', label: 'PIB', sortable: true },
      { id: 'mb', label: 'Matični broj', sortable: true },
      // ukoliko se ne prosledi sortable, onda se ne prikazuje strelica za sortiranje, i sort ne radi
      { id: '#1', label: '#' },
    ],
    []
  );

  return (
    <GenericPaginableTable
      subheader="Retaileri"
      isLoading={isLoading}
      errorMessage={errorMessage}
      totalCount={retailers?.length}
      currentPage={page}
      onPageChangeHandler={setPage}
      onChangeItemsPerPageHandler={setRowsPerPage}
      sortByHandler={setSortBy}
      itemsPerPage={rowsPerPage}
      tableBodyComponent={
        <RetailersTableBody
          retailers={dataToShow as Retailer[] | undefined}
          isLoading={isLoading}
        />
      }
      tableLabels={tableLabels}
    />
  );
};
